import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import Section from 'ui/atoms/section';
import Header from 'ui/atoms/header';
import { AdditionalInformationForm } from 'libraries/wizard/components/additional-information/additional-information-form';

const TaxInformation: FunctionComponent = () => {
  return (
    <Section spacing="large">
      <Header size="small">
        <Translate name="investmentAdditionalInformation.taxInformation.exemptionOrderAmount.title" />
      </Header>
      <AdditionalInformationForm.Group
        name="exemptionOrderAmount"
        info={<Translate name="additionalInformationForm.fields.exemptionOrderAmount.info" />}
      >
        <AdditionalInformationForm.Input type="number" isCurrency />
        {AdditionalInformationForm.Validators.Range(0, undefined)}
        {AdditionalInformationForm.Validators.MaxDecimals(2)}
      </AdditionalInformationForm.Group>
    </Section>
  );
};

export default TaxInformation;
